<template>
  <div style="position: relative;" :style="{width: windowInnerWidth, height: windowInnerHeight}">
  <div class="full-width"  v-loading="loading">
    <div  >
    <ul class="title-box" :style="{'background-image': `url(${publicPath}static/images/Topbg1.png)`,'background-size': 'cover'}">
      <li class="btn-part" style="text-align: left">
        <div style="padding: 5px;width: 50px; height: 50px;" >
          <img :src="`${publicPath}static/images/ShopopeeLogo.png`" style="width: 100%; height: 100%;user-select:none;"
               onerror="this.error = null">
        </div>
      </li>

      <li class="btn-part" style="text-align: left;">
        <div class="icon-part" @click="langSelectVisible = true">
          <div class="icon-text" >
            <font-awesome-icon icon="fa-solid fa-language" />
          </div>
          <span class="icon-span" tkey="語言">{{i18n.tkey("lang_lang")}}</span>
        </div>
      </li>

      <li class="text-part">
        <div style="padding: 0px 5px;" @click="goshowSearch" >
          <div style=" height: 36px;max-width: 480px; border: 1px solid black;margin: auto;text-align: left;display: flex;padding: 0px 5px;border-radius: 20px;background-color: #FFFFFF;">
            <div style="width: 100%;"></div>
            <el-text style="width:80px;text-align: center;padding: 5px 10px;background-color: #1a9aef;border-radius: 16px;color: #ffffff;">{{i18n.tkey("lang_search_text")}}</el-text>
          </div>

        </div>
      </li>
      <li class="btn-part" style="text-align: right;display: grid;grid-template-columns: 1fr 1fr;">

        <div style="width: 50px; height: 50px;" @click="selectCountryVisible = true"  >
          <img :src="`${publicPath}static/images/earth.png`" style="width: 100%; height: 100%;user-select:none;"
               onerror="this.error = null">
        </div>
        <div style="width: 50px; height: 50px;" @click="goLogind" v-show="userInfoRef.memberStatus === 0" >
          <img :src="`${publicPath}static/images/setting.png`" style="width: 100%; height: 100%;user-select:none;"
               onerror="this.error = null">
        </div>
        <div style="width: 50px; height: 50px;" @click="goAccountViewd" v-show="userInfoRef.memberStatus === -1" >
          <img :src="`${publicPath}static/images/setting.png`" style="width: 100%; height: 100%;user-select:none;"
               onerror="this.error = null">
        </div>
      </li>


    </ul>

      <el-row :style="{'background-image': `url(${publicPath}static/images/Topbg2.png)`,'background-size': 'cover'}">
        <el-col :span="8"  style="text-align: center;padding: 10px;">
          <div class="moving-box" @click="goIndex" >
            <div class="face front"  :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
            <img :src="`${publicPath}static/images/3dCity.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                 onerror="this.error = null">
            </div>
            <div class="face back" :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
              <img :src="`${publicPath}static/images/3dCity.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                   onerror="this.error = null">
            </div>
            <div class="face2 left">
            </div>
            <div class="face2 right">
            </div>
          </div>
        </el-col>
        <el-col :span="8" style="text-align: center;padding: 10px;">
          <div class="moving-box2"  @click="goHall">

            <div class="face front"  :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
            <img :src="`${publicPath}static/images/3dExpo.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                 onerror="this.error = null">
            </div>
            <div class="face back" :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
              <img :src="`${publicPath}static/images/3dExpo.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                   onerror="this.error = null">
            </div>
            <div class="face2 left">
            </div>
            <div class="face2 right">
            </div>
          </div>
        </el-col>
        <el-col :span="8" style="text-align: center;padding: 10px;" >
          <div class="moving-box" @click="goTVad" >

            <div class="face front"  :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
            <img :src="`${publicPath}static/images/3DShopopee.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                 onerror="this.error = null">
            </div>
            <div class="face back"  :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
              <img :src="`${publicPath}static/images/3DShopopee.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                   onerror="this.error = null">
            </div>
            <div class="face2 left">
            </div>
            <div class="face2 right">
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div ref="shopopeeBannerparent" style="height: calc(100% - 171px);" v-show="shopopeeBannerVisible === true" >
      <ShopopeeBanner
          :parentWidth="parentWidth"
          :parentHeight="parentHeight"
          :typeInser="true"
          @goCallbackMain = "goCallbackMain"
      />
    </div>

    <div style=" height: calc(100% - 171px);overflow-y: scroll;overflow-x: hidden;" v-show="selectCountryVisible === false && shopopeeBannerVisible ===false">
            <div  v-infinite-scroll="scrollLoadFunc" >
              <el-row :gutter="10">
                <el-col
                    :span="myUtil.isMobile()?12:6"
                    v-for="(value, index) in materialList"
                    :key="value.id"
                    class="record-box"
                >
                  <SearchMaterialResult
                      :obj="value"
                      :title="value.company.companyname"
                      :titleDes="`${value.company.wa}-${value.company.siojournal}`"
                      :imgUrl="myUtil.generateProductImg(value)"
                      :name="value.productname"
                      :description="value.description"
                      :cost="value.cost"
                      :btn-label="i18n.tkey('lang_click_to_view')"
                      :tag="'primary'"
                      :type="'primary'"
                      @click-go-shop="materialGoShop"
                  />
                </el-col>
              </el-row>
              <el-empty
                  :description="i18n.tkey('lang_temporary_no_data')"
                  v-show="materialList.length == 0"
              />
            </div>
    </div>


    <div class="footer">
      <div style="width: 100%;max-width: 401px;height: 100px; margin: auto;" :style="{'background-image': `url(${publicPath}static/images/dashboard.png)`,'background-size': 'cover'}" >

        <el-row style="padding-top:74px;">
          <el-col :span="12" style="text-align: center;padding-left:30px;">

            <el-text style="color: #ffffff;font-size: 18px;">{{numDow1}}</el-text>
          </el-col>
          <el-col :span="12" style="text-align: center;padding-right:30px;">

            <el-text style="color: #ffffff;font-size: 18px;">{{numDow2}}</el-text>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
    <div class="coutry-select-render" v-if="selectCountryVisible == true">
      <earthView @clickRegion="selectCountryCallback" :showCloseBtn="false" />
    </div>
  <div class="shopopee-chat-view" :class="shopopeeChatStatus === 'hide' ? 'shopopee-chat-view-retract' : 'shopopee-chat-view-extend'" v-show="shopopeeChatVisible === true">
    <div style="position: relative; width: 100%; height: calc(100% - 50px);margin-top: 50px;">
      <phoneDemo
          ref="shopopeePhone"
          @exec-command-complete="phoneCommandCallback"
          @login-complete="loginCallback"
          @goShopPosition="goShopPosition"
          @goThreeGuide="goThreeGuide"
          @clickAudio="clickAudio"
          @newShop="clickNewShop"
          @returnShopopee="clickReturnShopopee"
          :class="shopopeeChatStatus === 'hide' ? 'hide-phone' : 'show-phone'"
      />

      <div class="close-div" :class="shopopeeChatStatus === 'hide' ? 'close-div-hide' : 'close-div-show'" @click="hideShopopeeChatBox">
        <font-awesome-icon icon="fa-solid fa-xmark" />
      </div>
    </div>
  </div>

    <languageSelect v-if="langSelectVisible == true" @save-complete="langSelectVisible = false" />


  </div>
</template>

<script setup>
import {onMounted, ref, toRef, computed, getCurrentInstance, inject, provide, onBeforeMount, watch} from 'vue'
import { useUserinfo } from '@/stores/userinfo'
import myUtil from "@/util/util";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import { faXmark,faMobileScreenButton,faLanguage } from '@fortawesome/free-solid-svg-icons'
import SearchMaterialResult from "@/components/shopopee/dataDisplay/searchMaterialResult.vue";
import materialApi from "@/request/materialApi";
import phoneDemo from '@/views/phoneDemo.vue'
import earthView from "@/views/earthView"
import ShopopeeBanner from "@/views/ShopopeeBanner.vue";
import LanguageSelect from "@/components/Shopopee3D/ui/languageSelect.vue";

library.add(faXmark,faMobileScreenButton,faLanguage)

const { proxy } = getCurrentInstance()

const props = defineProps([])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())
// const companyInfoRef = toRef(useCompanyinfo())

const publicPath = process.env.BASE_URL

const loading = ref(false)


const materialList = ref([])
const companyList = ref([])
let pageNum = 1
let pageSize = 10
const pageObj = ref({})
const keyword = ref("")
const loadingFlag = ref(false)
//是否顯示語言選擇框
const langSelectVisible = ref(false)


//是否顯示選擇地區框
const selectCountryVisible = ref(false)


//是否顯示3dbanner
const shopopeeBannerVisible = ref(true)

//是否显示聊天窗口
let shopopeeChatVisible = ref(false)
let shopopeeChatStatus = ref("hide")
const width = window.innerWidth
const height = window.innerHeight
const windowInnerWidth = ref((window.innerWidth) + "px")
const windowInnerHeight = ref((window.innerHeight) + "px")
const parentWidth = ref(window.innerWidth)
const parentHeight = ref(100)

const numDow1 = ref(0)
const numDow2 = ref(0)

function scrollLoadFunc(){
  if (null != pageObj.value.hasNextPage && pageObj.value.hasNextPage === true){
  changePage(pageNum + 1)
  }
}

function goCallbackMain(){
  shopopeeBannerVisible.value = false
  changeKeyword()

}
function selectCountryCallback(obj){
  // getShopList()
  // userInfoRef.value.selectCountry = code
  userInfoRef.value.selectCountry = obj.countrycode
  userInfoRef.value.selectCountryName = obj.zh
  userInfoRef.value.selectCountryName2 = obj.en

  selectCountryVisible.value = false
  // islandSelectVisible.value = true
  // startViewVisible.value = false
}
function countTo(selector, target) {
  let start = 0;
  const count = () => {
    start += Math.floor(target/24);
    selector.value = start;

    if (start < target) {
      setTimeout(count, 50); // 每100毫秒更新一次计数
    }
  };
  count(); // 启动计数
}

function phoneCommandCallback(functionName, status, data){
  // if (functionName === "openPersonChat" || functionName === "goCardView"){
  shopopeeChatVisible.value = true
  // bottomInteractionUiVisible.value = false
  // upperRightUiVisible.value = false
  // nippleViewVisible.value = false
  // controlFlag = false
  setTimeout(() => {
    shopopeeChatStatus.value = "show"
  }, 25)
  // }
}
function loginCallback(){

}
function clickReturnShopopee() {
  hideShopopeeChatBox()

  setTimeout(() => {
    confirmReturnShopopee()
  }, 250)

}

function clickAudio() {

}
function clickNewShop() {
  hideShopopeeChatBox()
}

function confirmReturnShopopee() {
  openConfirm(i18n.tkey("lang_return_shopopee_confirm"), () => {
    window.location.href = `${proxy.$ShopopeeUrl}my_memberwork`
  })
}
function openConfirm(text, func, func2){
  // moveFlag = false
  // speed = 0
  // confirmVisible.value = true
  // confirmFunc = func
  // cancelFunc = func2
  // controlFlag = false
  // bottomInteractionUiVisible.value = false
  // upperRightUiVisible.value = false
  // nippleViewVisible.value = false
  // setTimeout(() => {
  //   confirmText.value = text
  // }, 1250)
}

function goThreeGuide() {
  hideShopopeeChatBox()

  // setTimeout(() => {
  //   controlFlag = false
  // }, 250)

}

function hideShopopeeChatBox() {
  if (shopopeeChatStatus.value === "hide"){
    return
  }
  shopopeeChatStatus.value = "hide"

  // setTimeout(() => {
  shopopeeChatVisible.value = false
  // bottomInteractionUiVisible.value = true
  // upperRightUiVisible.value = true
  // nippleViewVisible.value = true
  // controlFlag = true
  // }, 1450)
}
function goShopPosition(wa, siojournal, islandid) {
  // if (null != islandid && null != currIsland && islandid != currIsland.id){
    proxy.$router.push({path: `/${islandid}/index/${wa}/${siojournal}`})
  //   reload()
  // }else{
  //   regionMap.selectShopIndex = siojournal
  //   regionMap.currPage = Number(wa) - 1
  //   goNextRegion(false)
  // }

}

function goIndex(){
  proxy.$router.push({name: "demoIndex"})
}
function goHall(){
  userInfoRef.value.hid = null
  proxy.$router.push({name: "hall"})
}

function goTVad(){
  console.log("測試")
  proxy.$refs.shopopeePhone.goSearchView()
}
function goLogind() {
  proxy.$refs.shopopeePhone.goLoginView()

}

function goshowSearch(){

  proxy.$refs.shopopeePhone.goSearchView("material")
}

function goAccountViewd() {
    proxy.$refs.shopopeePhone.goDisplayIndexView()
}
function materialGoShop(obj){
  console.log(obj)
    const shareStr=  `${proxy.$ShopopeeUrl}productInfo?id=${obj.id}`
    window.location.href=shareStr
}
function changeKeyword() {
  if (pageNum === 1){
    companyList.value = []
    materialList.value = []
  }

  loadingFlag.value = true
  queryMaterialByPage(queryMaterialCallback)

}
function queryMaterialCallback(detail) {
  if (null != detail && detail.code === 200){
    // materialList.value = detail.detail.list
    materialList.value = materialList.value.concat(detail.detail.list)

    changePageObj(detail.detail)
  }else{
    materialList.value = []

    // myUtil.alertError(detail.msg)
  }
}
function changePage(num){
  pageNum = num
  changeKeyword()
}

function changePageObj(obj){
  if (null == pageObj.value.total || obj.total > pageObj.value.total || obj.pageNum != pageObj.value.pageNum){
    pageObj.value = obj
  }
}
async function queryMaterialByPage(callback) {

  const request = materialApi.queryMaterialAndCompanyByPage
  const params = request.getParams()

  params.productname = keyword.value
  params.pageNum = pageNum
  params.pageSize = pageSize


  request.send(params, (res) => {
    loadingFlag.value = false
    if (typeof callback === "function"){
      callback(res)
    }
  })

}

onMounted(() => {

  parentWidth.value = proxy.$refs.shopopeeBannerparent.offsetWidth;
  parentHeight.value  = proxy.$refs.shopopeeBannerparent.offsetHeight;
  // currViewName.value = props.viewName
  if (null != props.keyword){
    keyword.value = props.keyword
  }
  if (null == userInfoRef.value.selectCountry){
    selectCountryVisible.value = true
  }
if(shopopeeBannerVisible.value===false){
  changeKeyword()
}
  countTo(numDow1,getHoursTime(243,12))
  countTo(numDow2,getHoursTime(3200,0.5))
})

function getHoursTime(seleNum,conditionNum){
  var givenTime = '2024-11-15 00:00:00';

// 将给定时间字符串转换为Date对象
  var givenDate = new Date(givenTime);

// 获取当前时间
  var currentDate = new Date();

// 计算相差的毫秒数
  var diff = currentDate - givenDate;

// 将毫秒数转换为小时数
  var hoursDiff = diff / (1000 * 60 * 60);
  if(hoursDiff>conditionNum){
    seleNum++
  }
  return seleNum
}


/*function getCompanyInfo(){
  loading.value = true
  const request = companyApi.getCompanyInfo
  const params = request.getParams()

  params.companycode = userInfoRef.value.companycode

  request.send(params, getCompanyInfoCallback)
}*/

/*function getCompanyInfoCallback(res){
  loading.value = false
  if (res.code == 200){
    const obj = res.detail

    myUtil.mergeObj(obj, companyInfoRef.value)
  }else{
    myUtil.alertError(res.msg)
  }
}*/


</script>

<style scoped>

.moving-box {
  width: 104px;
  height: 80px;
  margin: auto;
  display: flex;
  transform-style: preserve-3d;
  animation: moveUpAndDown 4s infinite alternate;
}

.moving-box2 {
  width: 104px;
  height: 80px;
  margin: auto;
  display: flex;
  transform-style: preserve-3d;
  animation: moveUpAndDown2 4s infinite alternate;
}
.face {
  position: absolute;
  width: 104px;
  height: 80px;
  margin: auto;
  display: flex;
  background: #f0f0f0;
  border: 1px solid #ccc;
}
.face2 {
  position: absolute;
  width: 10px;
  height: 80px;
  margin: auto;
  display: flex;
  background: #f0f0f0;
  border: 1px solid #ccc;
}

.front {
  transform: translateZ(5px);
}

.back {
  transform: rotateY(180deg) translateZ(5px);
}

.right {
  transform: rotateY(90deg) translateZ(98px);
}

.left {
  transform: rotateY(-90deg) translateZ(5px);
}

@keyframes moveUpAndDown2 {
  from {
    transform: translateY(-20px) rotateY(-180deg);
  }
  to {
    transform: translateY(0) rotateY(180deg);
  }
}

@keyframes moveUpAndDown {
  from {
    transform: translateY(0) rotateY(-180deg);
  }
  to {
    transform: translateY(-20px) rotateY(180deg);
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  /* 其他样式，比如高度、背景色等 */
  background-color: transparent;
  color: white;
  text-align: center;
}

ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.title-box {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
  font-size: 18px;
  border-bottom: 1px #e9e9e9 solid;
  width: 100%;
  height: 100%;
}

.btn-part {
  width: 25%;
  font-size: 1.5em;
}
.search-result {
  width: 100%;
  height: calc(100% - 110px);
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}
.shopopee-chat-view-extend {
  background: #00000050;
}

.shopopee-chat-view-retract {
  background: #ffffff00;
}

.text-part {
  width: 70%;
}
.shopopee-chat-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 1.5s ease;
  overflow: hidden;
  z-index: 1001;
}
.btn-span {
  margin-left: 20px;
  margin-right: 20px;
}

.unvisible-savecard-iframe {
  position: absolute;
  left: 0;
  top: 200vh;
  width: 900px;
  height: 900px;
  z-index: 9999;
}

.full-width {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 15px;
}

.icon-text {
  margin-top: 5px;
  font-size: 36px;
  pointer-events: none;
}

.icon-span {
  display: none;
  pointer-events: none;
}
.icon-part{
  width: 50px;
  height: 50px;
  text-align: center;
}


.btn-part .icon-part {
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 50%;
  border: #2c3e50;
  margin-right: 10px;
  /*margin-bottom: 10px;*/
}

.btn-part .icon-part .icon-text {
  margin-top: 10px;
  font-size: 20px;
  pointer-events: none;
  padding-top: 8px;
}


.shopopee-chat-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 1.5s ease;
  overflow: hidden;
  z-index: 1001;
}

@media screen and (min-width: 520px) {
  .shopopee-chat-view .close-div {
    display: inline-block;
    font-size: 24px;
    line-height: 50px;
    color: white;
    position: absolute;
    /*left: 50%;*/
    top: -25px;
    right: 0;
    /*margin-top: -400px;*/
    /*margin-left: 275px;*/
    border-radius: 50%;
    width: 50px;
    height: 50px;
    text-shadow: 0 1px 0 #484f58;
    border: 1px solid #734e4e;
    background-color: red;
  //border: 1px solid #734e4e;
  //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
  //background: -webkit-linear-gradient(top, #e92323, #551d1d);
    /*transition: all 1.5s ease;*/
    z-index: 100;
  }
}

@media screen and (max-width: 520px) {
  .shopopee-chat-view .close-div {
    display: inline-block;
    font-size: 30px;
    line-height: 40px;
    color: white;
    position: absolute;
    right: 3px;
    top: -20px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    text-shadow: 0 1px 0 #484f58;
    border: 1px solid #734e4e;
    background-color: red;
  //border: 1px solid #734e4e;
  //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
  //background: -webkit-linear-gradient(top, #e92323, #551d1d);
    /*transition: all 1.5s ease;*/
    z-index: 100;
  }
}
.coutry-select-render {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
}
.shopopee-chat-view .close-div-hide {
  opacity: 0;
  transform: scale(0.5);
  animation: hide-shopopee-chat-close-div 0.5s ease;
}

</style>